import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/home-texts")({
  component: lazyRouteComponent(() => import("./-pages/admin.home-texts")),
  head: () => ({
    meta: [
      { title: "بلوك ٩ — إدارة" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
